import { BoardView } from '../../game/boardMVC/views/board/BoardView';
import type { BoardModel } from '../../game/boardMVC/models/board/BoardModel';
import type { BoardViewFactory } from '../../game/boardMVC/views/board/BoardViewFactory';

export const EMPTY_BACKGROUND_TILE_OPACITY = 0.25;

export class EditorBoardView extends BoardView {
  constructor(model: BoardModel, viewFactory: BoardViewFactory) {
    super(model, viewFactory);

    const { initialBounds } = this;

    this.fillEmptyBackgroundTiles(model.cols, model.rows);

    const bounds = this.background.getLocalBounds();
    initialBounds.set(bounds.x, bounds.y, bounds.width, bounds.height);
    this.pivot.set(initialBounds.x, initialBounds.y);
  }

  private fillEmptyBackgroundTiles(cols: number, rows: number): void {
    const { background } = this;
    for (let x = 0; x < cols; x += 1) {
      for (let y = 0; y < rows; y += 1) {
        if (!background.getTile(x, y)) {
          background.addTile(x, y)?.props({
            alpha: EMPTY_BACKGROUND_TILE_OPACITY,
          });
        }
      }
    }
  }
}
